<template>
  <div :key="language">
    <slot />
  </div>
</template>

<script lang="ts" setup>
const language = useCurrentLanguage()
</script>
